const th = {
  "lines": [
    "ชู่ว! เจอฉันหรือยัง?",
    "แบร่! แค่มาดูว่าเป็นยังไงบ้าง",
    "อย่าบอกใครนะว่าฉันอยู่ตรงนี้…",
    "ได้กลิ่นวาฟเฟิลจากที่ไหนสักแห่ง…",
    "เห็นน้ำตกของฉันไหม?",
    "ชู่ว… ฉันกำลังหลบนักล่าโทรลล์!",
    "เลื่อนต่อไปเลย — ฉันจับตาดูอยู่นะ!",
    "ถึง 1 กุมภาพันธ์หรือยัง?"
  ],
  "giant": [
    "สวัสดีคนข้างล่าง!",
    "ใครมาเลื่อนจอบนสะพานของฉัน?",
    "ฉันไม่ได้ตัวใหญ่ เธอต่างหากที่ตัวเล็ก"
  ],
  "golden": "เธอเห็นโทรลล์ทองคำแล้ว! มีแค่ไม่กี่คนที่โชคดีได้เห็นฉัน",
  "goldenTag": "ตำนาน"
};

export default th;
